
/**
 * Module dependencies.
 */

import { Helmet } from 'react-helmet';
import { MailTo } from 'client/components/core/mail-to';
import {
  PayspaceAuthenticationLayout
} from 'client/components/layouts/payspace-authentication-layout';

import { Text } from 'slyk-web-libs/design-system';
import { Trans } from 'react-i18next';
import { color, media } from 'react-components/styles';
import { getImageSources } from 'client/core/utils/image';
import { useTranslate } from 'slyk-web-libs/i18n';
import React from 'react';
import config from 'config';
import styled from 'styled-components';

/**
 * Slyk link.
 */

const slykLink = config.get<string>('externalLinks.slykWebsite');

/**
 * Support email.
 */

const supportEmail = config.get<string>('supportEmail');

/**
 * `Description` styled component.
 */

const Description = styled(Text).attrs({ size: 'large' })`
  margin-top: 24px;

  ${media.min('md')`
    margin-top: 40px;
  `}
`;

/**
 * `SupportEmail` styled component.
 */

const SupportEmail = styled(Text).attrs({ size: 'small' })`
  color: ${color('gray500')};
  padding-top: 8px;
`;

/**
 * Export `PayspaceNotActive` container.
 */

export function PayspaceNotActive(): JSX.Element {
  const { translate } = useTranslate();

  return (
    <>
      <Helmet>
        <title>
          {translate('notActive.metaTitle')}
        </title>
      </Helmet>

      <PayspaceAuthenticationLayout
        image={getImageSources('payspace-not-active-mobile', 'webp')}
        logoLink={slykLink}
        title={translate('notActive.title')}
      >
        <Description>
          {translate('notActive.description')}
        </Description>

        {supportEmail && (
          <SupportEmail>
            <Trans
              components={[(
                <MailTo
                  email={supportEmail}
                  key={0}
                />
              )]}
              i18nKey={'notActive.contactSupport'}
            />
          </SupportEmail>
        )}
      </PayspaceAuthenticationLayout>
    </>
  );
}
